import { z } from 'zod';

import { OrgIdSchema } from '../_shared/identifiers';

/**
 * Envelope-layer orgId — accepts the v1.1 single-tenant placeholder
 * '_default' OR a valid 24-char hex ObjectId. The repo-wide `OrgIdSchema`
 * stays strict so non-envelope identity surfaces continue to reject
 * '_default'; the blast radius of relaxation is confined here.
 */
export const EnvelopeOrgIdSchema = z.union([z.literal('_default'), OrgIdSchema]);

export type EnvelopeOrgId = z.infer<typeof EnvelopeOrgIdSchema>;
